import request from '@/utils/request';

const baseURL = '/financeapi/finance/setting/config/'

export const getSystemConfig = data =>
  request({
    data,
    url: `${baseURL}getSystemConfig`,
    method: 'post'
  });

export const addConfigDetails = data =>
  request({
    data,
    url: `${baseURL}addConfigDetails`,
    method: 'post'
  });

export const deleteConfigDetails = data =>
  request({
    data,
    url: `${baseURL}deleteConfigDetails`,
    method: 'post'
  });

export const updateSystemConfig = data =>
  request({
    data,
    url: `${baseURL}updateSystemConfig`,
    method: 'post'
  });

export const updateSystemVersion = (data) => {
  return request({
    data,
    url: `${baseURL}updateSystemVersion`,
    method: 'post'
  });
}
